export default __webpack_public_path__ + "static/media/gallery_01.053df09e.jpg";